import React from 'react';

function References() {
    return (
        <div>
            <h1>Referenzen</h1>
            <table>
                <thead>
                    <tr>
                        <th>Referenznummer</th>
                        <th>Titel</th>
                        <th>Objektart</th>
                        <th>Exposé-Status</th>
                        <th>Portal-Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>AP1-26-0301</td>
                        <td>Einfamilienhaus</td>
                        <td>Einfamilienhäuser</td>
                        <td>published</td>
                        <td>published</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default References;
